import loadComponent from './component';
import videoIcon from './icons/video.svg';
import { componentLabel, customComponentsCategory } from '../utils/editor';

function loadBlock(editor, options = {}) {
  editor.BlockManager.add(options.componentType, {
    label: componentLabel(options.componentName, videoIcon),
    category: options.category,
    content: '<SessionVideoPlayer />',
  });
}

export default function (editor, opts = {}) {
  const defaults = {
    componentType: 'SessionVideoPlayer',
    componentName: 'Session video player',
    category: customComponentsCategory,
  };

  loadBlock(editor, { ...defaults, ...opts });
  loadComponent(editor, { ...defaults, ...opts });
}
